"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapAnalyticsProperties = MapAnalyticsProperties;
const AnalyticsConstants_1 = require("./AnalyticsConstants");
const keyMappings = new Map([
    [
        AnalyticsConstants_1.SharedAppInsightsCustomProperties.CurrentOrganisationId,
        AnalyticsConstants_1.SharedRudderStackCustomProperties.UserOrganisationId,
    ],
    [
        AnalyticsConstants_1.SharedAppInsightsCustomProperties.LegacyOrganisationId,
        AnalyticsConstants_1.SharedRudderStackCustomProperties.UserOrganisationId,
    ],
]);
const keysToDelete = [
    AnalyticsConstants_1.SharedAppInsightsCustomProperties.CurrentOrganisationName,
];
// Maps common properties currently used for App Insights to RudderStack properties
function MapAnalyticsProperties(customProperties) {
    return customProperties
        ? renameKeys(setPatientUserIdFromOrganisationId(customProperties))
        : customProperties;
}
function renameKeys(customProperties) {
    const mappedKeys = Object.keys(customProperties).map((key) => {
        const newKey = keyMappings.get(key) || key;
        return { [newKey]: customProperties[key] };
    });
    const mappedProperties = Object.assign({}, ...mappedKeys);
    keysToDelete.forEach((key) => delete mappedProperties[key]);
    return mappedProperties;
}
/**
 * For patient, we are adding to the userId field a dummy guid generated from the userOrganisationId
 * The output mimics the backend implementation of setting the userId field.
 */
const BASE_ORG_ID_GUID_SUFFIX = "-0000-0000-0000-006f72674964";
function setPatientUserIdFromOrganisationId(customProperties) {
    const userOrganisationId = getUserOrganisationId(customProperties);
    const isPatient = isEventUserTypePatient(customProperties);
    const userId = customProperties[AnalyticsConstants_1.SharedCustomProperties.UserId];
    if (userOrganisationId !== null && isPatient && !userId) {
        return Object.assign(Object.assign({}, customProperties), { [AnalyticsConstants_1.SharedCustomProperties.UserId]: dummyGuidForOrganisation(userOrganisationId) });
    }
    return customProperties;
}
function getUserOrganisationId(customProperties) {
    const userOrganisationId = customProperties[AnalyticsConstants_1.SharedRudderStackCustomProperties.UserOrganisationId];
    return typeof userOrganisationId === "number" ? userOrganisationId : null;
}
function isEventUserTypePatient(customProperties) {
    return customProperties["eventUserType"] === AnalyticsConstants_1.EventUserType.Patient;
}
/**
 * Guid generated to be consistent with Server AnalyticsHelper implementation.
 * First 8 char are the hexadecimal value of userOrganisationId, padded with zeros.
 * Last 12 chars are the guid encoding of "orgId".
 */
function dummyGuidForOrganisation(userOrganisationId) {
    const hexOrganisationId = userOrganisationId
        .toString(16)
        .padStart(8, "0")
        .substring(0, 8);
    return hexOrganisationId + BASE_ORG_ID_GUID_SUFFIX;
}
//# sourceMappingURL=RudderStackAnalyticsMapper.js.map